import NotificationForMyselfOrLeadsSelect from './NotificationForMyselfOrLeadsSelect.component';

export default NotificationForMyselfOrLeadsSelect;
